import { ModelSagres } from "@/types/model-sagres";

export class UG extends ModelSagres {
    id?: number
    nmNome: string
    nmSigla: string
    nuCnpj: string
    idNaturezaJuridica: number | null
    idPoder: number | null
    idTipoUnidadegestora: number | null
    idMunicipio: number | null
    idEsfera: number | null
    idUnidadegestoraSuperior: number | null
    codUgSagres: string | null
    stEntregaFolhaPagto: number | null
    idUgSuperiorFolha: number | null
    mesInicio: number | null
    anoInicio: number

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.id || obj.Id)
                this.id = obj.id ?? obj.Id
            if (obj.nmNome || obj.NmNome)
                this.nmNome = obj.nmNome ?? obj.NmNome
            if (obj.nmSigla || obj.NmSigla)
                this.nmSigla = obj.nmSigla ?? obj.NmSigla
            if (obj.nuCnpj || obj.NuCnpj)
                this.nuCnpj = obj.nuCnpj ?? obj.NuCnpj
            if (obj.idNaturezaJuridica || obj.IdNaturezaJuridica)
                this.idNaturezaJuridica = obj.idNaturezaJuridica ?? obj.IdNaturezaJuridica
            if (obj.idPoder || obj.IdPoder)
                this.idPoder = obj.idPoder ?? obj.IdPoder
            if (obj.idTipoUnidadegestora || obj.IdTipoUnidadegestora)
                this.idTipoUnidadegestora = obj.idTipoUnidadegestora ?? obj.IdTipoUnidadegestora
            if (obj.idMunicipio || obj.IdMunicipio)
                this.idMunicipio = obj.idMunicipio ?? obj.IdMunicipio
            if (obj.idEsfera || obj.IdEsfera)
                this.idEsfera = obj.idEsfera ?? obj.IdEsfera
            if (obj.idUnidadegestoraSuperior || obj.IdUnidadegestoraSuperior)
                this.idUnidadegestoraSuperior = obj.idUnidadegestoraSuperior ?? obj.IdUnidadegestoraSuperior
            if (obj.codUgSagres || obj.CodUgSagres)
                this.codUgSagres = obj.codUgSagres ?? obj.CodUgSagres
            this.stEntregaFolhaPagto = obj.stEntregaFolhaPagto ?? obj.StEntregaFolhaPagto ?? null
            if (obj.idUgSuperiorFolha || obj.IdUgSuperiorFolha)
                this.idUgSuperiorFolha = obj.idUgSuperiorFolha ?? obj.IdUgSuperiorFolha
            if (obj.mesInicio || obj.MesInicio)
                this.mesInicio = obj.mesInicio ?? obj.MesInicio
            if (obj.anoInicio || obj.AnoInicio)
                this.anoInicio = obj.anoInicio ?? obj.AnoInicio
        }
    }
}
